/** Parse comma- or semicolon-separated recipe tag text from model forms. */
export function parseRecipeTagsInput(raw: string): string[] {
  return raw
    .split(/[,;]/)
    .map((s) => s.trim())
    .filter((s) => s.length > 0);
}

export function formatRecipeTagsInput(tags: readonly string[]): string {
  return tags.join(", ");
}
